import moment from "moment/moment";

export const formatDateToBirthday = (birthday: Date | null): string => {
  //! NOTE: CustomDatepicker return a date back like "2012-12-05T23:00:00.000Z" format
  return moment(birthday).format("DD.MM.YYYY");
};